'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bookingMetaDataActions = require('actions/bookingMetaDataActions');

function bookingMeta() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _bookingMetaDataActions.BOOKING_META_DATA_RECEIVED:
            return action.bookingMetaData;
        default:
            return state;
    }
}

exports.default = bookingMeta;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/reducers/bookingMeta.js
// module id = 1393
// module chunks = 0